jQuery(document).ready(function ($) {

  $(document).on('click', '.ct-ostria', function () {
    $("#buttons li").removeClass("bactive");
    $(this).addClass("bactive");

    $(".table-ostria").show();
    $(".table-poise, .table-studio-shirt, .table-studio-pants, .table-column, .table-shift").hide();
  });

  $(document).on('click', '.ct-poise', function () {
    $("#buttons li").removeClass("bactive");
    $(this).addClass("bactive");

    $(".table-poise").show();
    $(".table-ostria, .table-studio-shirt, .table-studio-pants, .table-column, .table-shift").hide();
  });

  $(document).on('click', '.ct-studio-shirt', function () {
    $("#buttons li").removeClass("bactive");
    $(this).addClass("bactive");

    $(".table-studio-shirt").show();
    $(".table-ostria, .table-poise, .table-studio-pants, .table-column, .table-shift").hide();
  });

  $(document).on('click', '.ct-studio-pants', function () {
    $("#buttons li").removeClass("bactive");
    $(this).addClass("bactive");

    $(".table-studio-pants").show();
    $(".table-ostria, .table-poise, .table-studio-shirt, .table-column, .table-shift").hide();
  });

  $(document).on('click', '.ct-column', function () {
    $("#buttons li").removeClass("bactive");
    $(this).addClass("bactive");

    $(".table-column").show();
    $(".table-ostria, .table-poise, .table-studio-shirt, .table-studio-pants, .table-shift").hide();
  });

  $(document).on('click', '.ct-shift', function () {
    $("#buttons li").removeClass("bactive");
    $(this).addClass("bactive");

    $(".table-shift").show();
    $(".table-ostria, .table-poise, .table-studio-shirt, .table-studio-pants, .table-column").hide();
  });

});